export default __webpack_public_path__ + "static/media/purple-list.473f6497.png";